module.exports = __webpack_public_path__ + "static/media/biteship-via-web-app.6a414a38.png";